<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallNumGroupList></CallNumGroupList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../../layouts/BasicLayout';
  import CallNumGroupList from '../../../../components/tsConfig/hytalkPro/system/CallNumGroupList';

  export default {
    name: 'SystemCallNumGroup',
    components: {
      BasicLayout,
      CallNumGroupList
    },
    data() {
      return {
        left: {
          show: false,
          name: ''
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: '111/22222/33333'
        }
      };
    }
  };
</script>

<style scoped>

</style>
